import { Record, List } from 'immutable';

/**
 * @deprecated
 */
export default class BookingResourceRecord extends Record({
  id: undefined,
  booked: undefined,
  confirmationEmailSentAt: undefined,
  confirmationSignedAt: undefined,
  confirmationStatus: undefined,
  customerReplacementModel: undefined,
  holidayPayRate: undefined,
  invoiceItems: undefined,
  links: undefined,
  mileageAllowanceEnabled: undefined,
  overriddenCustomerFee: undefined,
  overriddenResourceFee: undefined,
  paymentItems: undefined,
  publicTimeReport: false,
  reported: undefined,
  resourceAgreement: undefined,
  resourceId: undefined,
  resourceName: undefined,
  resourceReplacementModel: undefined,
  wageSupportHourlyAmount: undefined,
  maxWageAmount: undefined,
  // Work-type ids this resource's shifts can carry, resolved server-side
  // (resource agreement's for a derived booking, customer agreement's otherwise).
  // Only the time-report payload populates it; empty elsewhere.
  workTypes: new List(),
}) {
}
